import { computed, Service, signal } from '@angular/core';
import {
	DEFAULT_SYMBOL_DETAIL_LAYOUT,
	pickSymbolDetailLayout,
	SYMBOL_DETAIL_LAYOUT_STORAGE_KEY,
	SymbolDetailLayout,
	SymbolDetailSectionId
} from '../../../models/symbol-detail-section.model';

@Service()
export class SymbolDetailLayoutStore {
	private readonly symbolDetailLayout = signal<SymbolDetailLayout>(this.readSymbolDetailLayout());

	readonly sectionOrder = computed(() => this.symbolDetailLayout().sectionOrder);

	readonly expanded = computed(() => this.symbolDetailLayout().expanded);

	isExpanded(section: SymbolDetailSectionId): boolean {
		return this.symbolDetailLayout().expanded[section];
	}

	saveSectionOrder(sectionOrder: readonly SymbolDetailSectionId[]): boolean {
		return this.persist({ ...this.symbolDetailLayout(), sectionOrder: [...sectionOrder] });
	}

	setExpanded(section: SymbolDetailSectionId, expanded: boolean): boolean {
		return this.persist({
			...this.symbolDetailLayout(),
			expanded: { ...this.symbolDetailLayout().expanded, [section]: expanded }
		});
	}

	resetToDefault(): boolean {
		return this.persist(DEFAULT_SYMBOL_DETAIL_LAYOUT);
	}

	private persist(next: SymbolDetailLayout): boolean {
		const canonical = pickSymbolDetailLayout(next);
		this.symbolDetailLayout.set(canonical);

		try {
			localStorage.setItem(SYMBOL_DETAIL_LAYOUT_STORAGE_KEY, JSON.stringify(canonical));
			return true;
		} catch {
			return false;
		}
	}

	private readSymbolDetailLayout(): SymbolDetailLayout {
		try {
			const raw = localStorage.getItem(SYMBOL_DETAIL_LAYOUT_STORAGE_KEY);
			return pickSymbolDetailLayout(raw ? JSON.parse(raw) : null);
		} catch {
			return pickSymbolDetailLayout(null);
		}
	}
}
